import { Stack, Typography, useTheme } from "@mui/material";
import { type FC, useMemo } from "react";
import type {
	PortfolioListItemResponseDTO,
	PortfolioListReportingSummaryResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { CommonListItem } from "web_myplann/Portfolio/Components/CommonListItem";
import { getPortfolioIcon } from "web_myplann/Portfolio/Helpers/getPropertyIcon";
import { getTitle, renderThirdRow } from "./portfolioListItemHelpers";

type Props = {
	data: PortfolioListItemResponseDTO;
	summaryData: PortfolioListReportingSummaryResponseDTO[] | undefined;
	onClick: () => void;
};

export const PortfolioListItemTitle: FC<Props> = ({
	data,
	summaryData,
	onClick,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	const element = useMemo(() => {
		const title = getTitle(data, t);
		const thirdRow = renderThirdRow(data, summaryData, t, theme);

		return (
			<Stack direction="column" sx={{ minWidth: 0 }}>
				<Typography
					variant="deprecatedH3"
					color={theme.palette.deprecated.grey[700]}
					sx={{
						overflow: "hidden",
						textOverflow: "ellipsis",
						whiteSpace: "nowrap",
					}}
				>
					{title}
				</Typography>
				<Typography
					variant="deprecatedBodyStrong"
					color={theme.palette.deprecated.grey[500]}
					overflow="hidden"
					whiteSpace="nowrap"
					textOverflow="ellipsis"
				>
					{data.producer}
				</Typography>
				<Stack>{thirdRow}</Stack>
			</Stack>
		);
	}, [data, theme, summaryData, t]);

	return (
		<CommonListItem
			icon={data.icon ?? getPortfolioIcon(theme, undefined, data.domain)}
			iconText={data.iconText ?? undefined}
			iconColor={data.domainColor ?? undefined}
			element={element}
			onClick={onClick}
		/>
	);
};
